import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { FeatureFlag } from '@app/enums';
import { FeatureService } from '@app/services/feature.service';
import { BaseForm } from '@forms/base.form';
import { Role } from '@models/account/role.model';
import { EmployeeAccessLevels, Levels, Profile } from '@settings/interfaces/profile-permissions.interface';
import { RolePermissionsMenuService } from './role-permissions-menu.service';

enum FieldLevels {
    edit = 'settings.role-permissions.edit',
    view = 'settings.role-permissions.viewOnly',
    noAccess = 'settings.role-permissions.noAccess',
}

type Field = Levels | 'noAccess';

@Component({
    selector: 'app-form-role-permissions',
    templateUrl: './role-permissions.template.html',
    styleUrls: ['./role-permissions.style.scss'],
    providers: [RolePermissionsMenuService],
})
export class RolePermissionsForm extends BaseForm implements OnInit {
    ACCESS_LEVELS = EmployeeAccessLevels;
    FIELD_LEVELS = FieldLevels;
    @Input() role: Role = new Role();
    @Input() profilePermissions: Profile[];
    @Input() employeeAccessLevel: string = this.ACCESS_LEVELS.all;
    @Output() employeeAccessLevelChange: EventEmitter<string> = new EventEmitter<string>();
    appliedAllFields: Field = Levels.edit;
    tab = 'personal';
    isSurveyPerformanceSplit = false;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private featureService: FeatureService,
        public menuService: RolePermissionsMenuService
    ) {
        super();
        if (!this.route.snapshot.queryParams.tab) {
            this.router.navigate([], { queryParams: { tab: this.tab } });
        }
    }

    async ngOnInit(): Promise<void> {
        this.isSurveyPerformanceSplit = await this.featureService.has(FeatureFlag.performanceModuleSplit);

        this.route.queryParams.subscribe(() => {
            this.tab = this.route.snapshot.queryParams.tab;
        });
    }

    onAccessLevelChange(accessLevel: string): void {
        this.employeeAccessLevelChange.emit(accessLevel);
    }

    onSetAllFields(field: Field): void {
        if (this.role.isImmutable) return;

        this.appliedAllFields = field;
        const newLevel = field === 'noAccess' ? null : field;
        this.profilePermissions
            .find((profilePermission) => profilePermission.tab === this.tab)
            // We reject segments hidden by "feature flags" otherwise we unintentionally enable modules for the role
            // See https://gethumi.atlassian.net/browse/SQE-5271
            // This condition should only run when the feature flag is active
            .segments.filter((segment) => (this.isSurveyPerformanceSplit ? !segment.hideIfHasFeatureFlag : true))
            .forEach((segment) => (segment.level = newLevel));
    }

    openSelect(select: MatSelect): void {
        select.open();
    }
}
